import { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import { api, formatMoney } from "@/lib/api";

export default function SharedDayPage() {
  const { token } = useParams();
  const [d, setD] = useState(null);
  const [err, setErr] = useState(null);
  useEffect(() => {
    (async () => {
      try {
        const { data } = await api.get(`/public/day/${token}`);
        setD(data);
      } catch (e) {
        setErr(e.response?.data?.detail || "Not found");
      }
    })();
  }, [token]);

  if (err) return <div className="min-h-screen bg-[#0F0E0C] flex items-center justify-center text-[#B56258] font-mono">{err}</div>;
  if (!d) return <div className="min-h-screen bg-[#0F0E0C] flex items-center justify-center text-[#A39A8E] font-mono">Loading…</div>;
  const c = d.trader.currency;

  return (
    <div className="min-h-screen grain relative bg-[#0F0E0C] text-[#EBE5D9]">
      <header className="border-b border-[#2E2A25] px-6 py-4 flex items-center justify-between">
        <div className="flex items-center gap-3">
          <div className="w-8 h-8 border border-[#CFA66A] flex items-center justify-center"><span className="font-mono text-[#CFA66A] text-xs">FJ</span></div>
          <span className="font-head">FOREX JOURNAL</span>
        </div>
        <Link to="/" className="font-mono text-xs uppercase tracking-widest text-[#CFA66A] hover:text-[#EBE5D9]">Start your journal →</Link>
      </header>
      <main className="max-w-2xl mx-auto px-6 py-12 relative z-10 fade-in">
        <p className="font-mono text-[11px] uppercase tracking-[0.3em] text-[#CFA66A] mb-2">— Shared day</p>
        <h1 className="font-head text-4xl font-bold">{d.date}</h1>
        <p className="text-[#A39A8E] mt-1">by <Link to={`/u/${d.trader.handle}`} className="text-[#CFA66A] hover:text-[#EBE5D9]">{d.trader.name}</Link></p>

        {d.no_positions ? (
          <div className="mt-8 border border-[#5C7C8A]/40 bg-[#5C7C8A]/5 p-6 rounded-sm text-center">
            <p className="font-head text-2xl">No positions taken.</p>
            <p className="text-sm text-[#A39A8E] mt-2">A quiet, patient day.</p>
          </div>
        ) : (
          <>
            <div className="mt-8 border border-[#2E2A25] bg-[#1A1815] p-6 rounded-sm">
              <p className="font-mono text-[9px] uppercase tracking-widest text-[#A39A8E]">Day P&amp;L</p>
              <p className={`font-mono text-3xl mt-1 ${d.total_pnl >= 0 ? "text-[#7A9E80]" : "text-[#B56258]"}`}>{formatMoney(d.total_pnl, c)}</p>
            </div>
            <div className="mt-4 space-y-3">
              {d.trades.map((t, i) => (
                <div key={i} className="border border-[#2E2A25] bg-[#1A1815] p-4 rounded-sm">
                  <div className="flex justify-between font-mono text-sm">
                    <span>{t.pair} {String(t.direction).toUpperCase()} · {t.lot_size} lots · {t.entry} → {t.exit}</span>
                    <span className={t.pnl > 0 ? "text-[#7A9E80]" : t.pnl < 0 ? "text-[#B56258]" : ""}>{formatMoney(t.pnl, c)}</span>
                  </div>
                  {t.summary && <p className="text-sm text-[#EBE5D9] mt-2 whitespace-pre-wrap">{t.summary}</p>}
                </div>
              ))}
            </div>
            {[["Setup", d.setup_strategy], ["Reasoning", d.entry_exit_reasoning], ["Emotions", d.emotions], ["Mistakes", d.mistakes], ["Lessons", d.lessons]].filter(([, v]) => v).map(([label, val]) => (
              <div key={label} className="mt-4 border border-[#2E2A25] bg-[#1A1815] p-4 rounded-sm">
                <p className="font-mono text-[9px] uppercase tracking-widest text-[#CFA66A]">{label}</p>
                <p className="text-sm text-[#EBE5D9] mt-2 whitespace-pre-wrap">{val}</p>
              </div>
            ))}
          </>
        )}
      </main>
    </div>
  );
}
